module.exports = __webpack_public_path__ + "img/shinhan_logo.d4364e6.png";